import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';

function PrivacyPolicy({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${get(page, 'meta.name')}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <div className="container my-5">
        <div className="row my-5">
          <div className="col-lg-8 mx-lg-auto" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
        </div>
      </div>
    </PageWrapper>
  );
}

PrivacyPolicy.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'privacy_policy',
})(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/index.js